import React, { useEffect, useState } from 'react';
import Button from '../ui/button';
import { COLORS } from '../../constants';
import { applicationConfig } from '../../config/applicationConfig';

const FormField = ({
  type = 'text',
  name,
  label,
  value,
  onChange,
  required = false,
  list
}) => {
  const inputClasses = [
    'w-full rounded border-2 bg-transparent px-3 py-3 text-sm text-white placeholder-gray-400 outline-none transition-colors',
    'border-[#db0058] focus:border-[#b8004a]'
  ].join(' ');

  return (
    <label className="block">
      <span className="mb-2 block text-sm font-semibold text-white">{label}</span>
      <input
        type={type}
        name={name}
        value={value}
        onChange={onChange}
        required={required}
        list={list}
        className={inputClasses}
      />
    </label>
  );
};

const ApplicationForm = ({
  positionOptions = [],
  selectedPosition = '',
  positionPrefillKey = 0
}) => {
  const [formData, setFormData] = useState({
    firstName: '',
    surname: '',
    email: '',
    telephone: '',
    position: ''
  });

  useEffect(() => {
    if (!selectedPosition) {
      return;
    }

    setFormData(prev => ({
      ...prev,
      position: selectedPosition
    }));
  }, [selectedPosition, positionPrefillKey]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const generateEmailBody = () => {
    const body = `Dear Hiring Team,

I am writing to apply for the position of: ${formData.position}

Personal Details:
Name: ${formData.firstName} ${formData.surname}
Email: ${formData.email}
Telephone: ${formData.telephone}

Please find my CV attached to this email.

Best regards,
${formData.firstName} ${formData.surname}`;

    return encodeURIComponent(body);
  };

  const generateSubject = () => {
    const jobTitle = formData.position || 'Job Application';
    return encodeURIComponent(`Application: ${jobTitle}`);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const subject = generateSubject();
    const body = generateEmailBody();
    const mailtoLink = `mailto:${applicationConfig.careersEmail}?subject=${subject}&body=${body}`;

    window.location.href = mailtoLink;
  };

  return (
    <div className="overflow-hidden rounded-lg border border-white/10 bg-[#2f3134] shadow-xl">
      <div
        className="px-5 py-4 text-white"
        style={{ backgroundColor: COLORS.primary }}
      >
        <h2 className="text-xl font-semibold">Submit your application</h2>
      </div>

      <div className="p-5 sm:p-6">
        <form onSubmit={handleSubmit} className="space-y-5">
          <div className="grid grid-cols-1 gap-5 sm:grid-cols-2">
            <FormField
              name="firstName"
              label="First name*"
              value={formData.firstName}
              onChange={handleInputChange}
              required
            />

            <FormField
              name="surname"
              label="Surname*"
              value={formData.surname}
              onChange={handleInputChange}
              required
            />
          </div>

          <FormField
            type="email"
            name="email"
            label="Email address*"
            value={formData.email}
            onChange={handleInputChange}
            required
          />

          <FormField
            type="tel"
            name="telephone"
            label="Telephone number*"
            value={formData.telephone}
            onChange={handleInputChange}
            required
          />

          <FormField
            name="position"
            label="Position applied for*"
            value={formData.position}
            onChange={handleInputChange}
            list={positionOptions.length > 0 ? 'career-position-options' : undefined}
            required
          />
          {positionOptions.length > 0 && (
            <datalist id="career-position-options">
              {positionOptions.map((position) => (
                <option key={position} value={position} />
              ))}
              <option value="Speculative application" />
            </datalist>
          )}

          <Button
            type="submit"
            variant="primary"
            size="medium"
            className="w-full"
          >
            Submit application
          </Button>
        </form>
      </div>
    </div>
  );
};

export default ApplicationForm;
